import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { moduleName } from './constants'
import { ILedByGPO, IILedByGPOState } from './types'

import { ResponseWithPagination } from 'constants/types'

const initialState: IILedByGPOState = {
  search: null,
  list: [],
  total: 0,
  isLoading: false,
  isLoaded: false,
  error: null
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    loading(state: IILedByGPOState) {
      state.isLoading = true
      state.error = null
    },
    finish(state: IILedByGPOState) {
      state.isLoading = false
    },
    error(
      state: IILedByGPOState,
      action: PayloadAction<{ error: IILedByGPOState['error'] }>
    ) {
      const { error } = action.payload
      state.error = error
    },
    set(
      state: IILedByGPOState,
      action: PayloadAction<
        ResponseWithPagination<ILedByGPO> & Pick<IILedByGPOState, 'search'>
      >
    ) {
      state.search = action.payload.search
      state.list = action.payload.results
      state.total = action.payload.count
    },
    bulk(state: IILedByGPOState, action: PayloadAction<ILedByGPO[]>) {
      state.list = [...state.list, ...action.payload]
    },
    reset(state: IILedByGPOState) {
      Object.keys(initialState).forEach((key) => {
        state[key as string] = initialState[key]
      })
    }
  }
})

export default slice.reducer
export const { loading, finish, error, set, bulk, reset } = slice.actions
